import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


import FormHelperText from '@mui/material/FormHelperText';

import CircularProgress from '@mui/material/CircularProgress';
import { FaArrowLeft, FaPlus, FaFirstAid, FaCheck, FaCheckCircle } from 'react-icons/fa';

import MyButton from '../../../utils/MyButton';
import { getMobiliarios, postMobiliario, clearErrors } from '../../../redux/actions/mobiliarioactions';
import './NuevoMobiliario.css';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button
} from '@mui/material';
export class NuevoMobiliario extends Component {
    constructor(){
        super();
        this.state={

            idinventario:'',
            nombre:'',
            marca:'',
            registroinvima:'',
            modelo:'',
            serie:'',
            ubicacion:'',
            servicio:'',
            tipo:'',
             movilfijo:'',
            reqcalibracion:'',
            adquisicion:'',
            fechaadquisicion:'',
            costo:'',
            fabricacion:'',
            operacion:'',
            vidautil:'',
            proveedor:'',
            proveedortel:'',
            proveedoremail:'',
            
            tipotec:'',
            fuente:'',
            tensionmin:'',
            tensionmax:'',
            corrientemax:'',
            corrientemin:'',
            presion:'',
            temperatura:'',
            potencia:'',
            frecuencia:'',
            alto:'',
            ancho:'',
            largo:'',
            peso:'',
            urlmanual:'',
            urlfactura:'',
            urlmanualuser:'',
            urlimportacion:'',
            idprestador:'',
            imagenurl:'',
            errors:{},
            aprobado:{},
            fechainstalacion:'',
            garantia:'',
            fechainiciogarantia:'',
            fechafingarantia:'',
            velocidad:'',
            capacidad:'',
            tipouso:'',
            pais:'',
            descripcion:'',
            nombrefabricante:'',
            emailfabricante:'',
            telfabricante:'',
            rutinamto:'',
            recomendaciones:'',
            accesorio:'',
            accesorionombre1:'',
            accesorioref1:'',
            accesorioserie1:'',
            accesorionombre2:'',
            accesorioref2:'',
            accesorioserie2:'',
            accesorionombre3:'',
            accesorioref3:'',
            accesorioserie3:'',
            open:false
        };
        
    };

    static getDerivedStateFromProps(props, state) {
      const newState = {};
  
      if (props.UI.errors) {
          newState.errors = props.UI.errors;
      }
  
      if (props.UI.aprobado) {
         newState.aprobado = props.UI.aprobado;
      }
  
      return Object.keys(newState).length > 0 ? newState : null;
  }

 

    handleOpen=()=>{
        this.setState({open:true});
        };
 handleClose=()=>{

    //Verificar el mensaje de aprobado Si esta Aprobado entonces hacer un Get Equipos 
    //Sino está aprobado mantener la informacion ingresa y solo cambiar el estado que abre y cierra el Dialog. 

    if(this.state.aprobado.mensaje){
        this.props.getMobiliarios(this.props.clienteId);
        this.setState({ 
            idinventario:'',
            nombre:'',
            marca:'',            
            modelo:'',
            serie:'',
            ubicacion:'',
            servicio:'',
            tipo:'',         
            movilfijo:'',            
            reqcalibracion:'',
            adquisicion:'',
            costo:'',
            fabricacion:'',
            operacion:'',
            vidautil:'',
            proveedor:'',
            proveedortel:'',
            proveedoremail:'',
            idprestador:'',
            tipotec:'',
            fuente:'',
            tensionmin:'',
            tensionmax:'',
            corrientemax:'',
            corrientemin:'',
            presion:'',
            temperatura:'',
            potencia:'',
            frecuencia:'',
            alto:'',
            ancho:'',
            largo:'',
            peso:'',
            urlmanual:'',
            urlfactura:'',
            fechainstalacion:'',
            garantia:'',
            fechainiciogarantia:'',
            fechafingarantia:'',
            velocidad:'',
            capacidad:'',
            tipouso:'',
            pais:'',
            descripcion:'',
            nombrefabricante:'',
            emailfabricante:'',
            telfabricante:'',
            rutinamto:'',
            recomendaciones:'',
            accesorio:'',
            accesorionombre1:'',
            accesorioref1:'',
            accesorioserie1:'',
            accesorionombre2:'',
            accesorioref2:'',
            accesorioserie2:'',
            accesorionombre3:'',
            accesorioref3:'',
            accesorioserie3:'',
            open:false,errors:{},aprobado:{}});
     }else{
      this.setState({open:false,errors:{},aprobado:{}});
     }

  //Cerrar e Inicializar los estados dependiendo del estado de aprobado 
           
 };
        handleChange=(event)=>{
              const { name, value } = event.target;
            if (name === 'garantia' && value === 'false') {
              // If warranty is set to false, clear warranty dates
              this.setState({
                [name]: value,
                fechainiciogarantia: '',
                fechafingarantia: ''
              });
            } else if (name === 'accesorio' && value === 'false') {
              // If accessories is set to false, clear all accessory fields
              this.setState({
                [name]: value,
                accesorionombre1: '',
                accesorioref1: '',
                accesorioserie1: '',
                accesorionombre2: '',
                accesorioref2: '',
                accesorioserie2: '',
                accesorionombre3: '',
                accesorioref3: '',
                accesorioserie3: ''
              });
            } else {
              // Default handling for all other fields
              this.setState({ [name]: value });
            }  
          
          };


    handleSubmit=(event)=>{
            event.preventDefault();

          
            const newUserData={
                idprestador:this.props.clienteId,
                nombre:this.state.nombre,
                idinventario:this.state.idinventario,
                marca:this.state.marca,
                modelo:this.state.modelo,
                serie:this.state.serie,
                servicio:this.state.servicio,
                ubicacion:this.state.ubicacion,
                tipo:this.state.tipo,
                imagenurl:this.state.imagenurl,
                movilfijo:this.state.movilfijo,
                reqcalibracion:this.state.reqcalibracion,
                adquisicion:this.state.adquisicion,
                costo:this.state.costo,
                fabricacion:this.state.fabricacion,
                fechaadquisicion:this.state.fechaadquisicion,
               
                vidautil:this.state.vidautil,
                proveedor:this.state.proveedor,
                proveedortel:this.state.proveedortel,
                proveedoremail:this.state.proveedoremail,                
                tipotec:this.state.tipotec,
                fuente:this.state.fuente,
                tensionmin:this.state.tensionmin,
                tensionmax:this.state.tensionmax,
                corrientemax:this.state.corrientemax,
                corrientemin:this.state.corrientemin,
                presion:this.state.presion,
                temperatura:this.state.temperatura,
                potencia:this.state.potencia,
                frecuencia:this.state.frecuencia,
                alto:this.state.alto,
                ancho:this.state.ancho,
                largo:this.state.largo,
                peso:this.state.peso,               
                urlmanual:this.state.urlmanual,
                urlfactura:this.state.urlfactura,
                urlmanualuser:this.state.urlmanualuser,
                urlimportacion:this.state.urlimportacion,
                fechainstalacion:this.state.fechainstalacion,
                garantia:this.state.garantia,
                fechainiciogarantia:this.state.fechainiciogarantia,
                fechafingarantia:this.state.fechafingarantia,
                velocidad:this.state.velocidad,
                capacidad:this.state.capacidad,
                tipouso:this.state.tipouso,
               
                pais:this.state.pais,
                descripcion:this.state.descripcion,
                nombrefabricante:this.state.nombrefabricante,
                emailfabricante:this.state.emailfabricante,
                telfabricante:this.state.telfabricante,
                rutinamto:this.state.rutinamto,
                recomendaciones:this.state.recomendaciones,
                accesorio:this.state.accesorio,
                accesorionombre1:this.state.accesorionombre1,
                accesorioref1:this.state.accesorioref1,
                accesorioserie1:this.state.accesorioserie1,
                accesorionombre2:this.state.accesorionombre2,
                accesorioref2:this.state.accesorioref2,
                accesorioserie2:this.state.accesorioserie2,
                accesorionombre3:this.state.accesorionombre3,
                accesorioref3:this.state.accesorioref3,
                accesorioserie3:this.state.accesorioserie3,
                
          };
          console.log(newUserData)
         this.props.postMobiliario(newUserData);
           
           
         
     }

    render() {
        const { UI:{loading}}=this.props; 
        const {errors}=this.state;
        return (
          

        
            <Fragment>

                  <div className='div-card-link' onClick={this.handleOpen}>
                    <div className="dashing-cardcontent">
                                        <div className="dashing-cardtext">
                                            <p className="dashing-text-card">
                                            Nuevo Activo
                                            </p>
                        
                                        </div>
                                        <div className="dashing-cardicon">
                                            <FaFirstAid color="#FFFFFF" className="dashing-icon"/>
                                        </div>
                                    </div>
  
  
                </div>
                
                <Dialog
             open={this.state.open}
             onClose={this.handleClose}
             fullWidth
             maxWidth="sm"
            >
 {this.state.aprobado.mensaje ? (
              
              <div className='div-aprobado'>
                  <div className='div-icono-aprobado'>
                    <FaCheck color="#ffffff" className='icono-aprobado'/>
                  </div>
                  <h2 className='text-aprobado'>Equipo Cargado Exitosamente</h2>
                  
                 
              </div>
                
                ) : (<div>
                    
               
            
               
           <DialogContent dividers>
  <Typography
    sx={{
      color: '#0468BF',
      fontSize: '18px',
      fontWeight: 400,
      ml: 1,
      mb: 2
    }}
  >
    Ingresa un Activo
  </Typography>

  <Grid container spacing={2}>
    <Grid item xs={12}>
      <TextField
        required
        name="nombre"
        label="Nombre del Activo"
        value={this.state.nombre}
        onChange={this.handleChange}
        fullWidth
        variant="outlined"
        size="small"
        helperText={errors.nombre}
        error={Boolean(errors.nombre)}
      />
    </Grid>

    <Grid item xs={12}>
      <TextField
        required
        name="idinventario"
        label="ID Inventario"
        value={this.state.idinventario}
        onChange={this.handleChange}
        fullWidth
        variant="outlined"
        size="small"
        helperText={errors.idinventario}
        error={Boolean(errors.idinventario)}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        required
        name="serie"
        label="Número de Serie"
        value={this.state.serie}
        onChange={this.handleChange}
        fullWidth
        variant="outlined"
        size="small"
        helperText={errors.serie}
        error={Boolean(errors.serie)}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        required
        name="modelo"
        label="Modelo del Equipo"
        value={this.state.modelo}
        onChange={this.handleChange}
        fullWidth
        variant="outlined"
        size="small"
        helperText={errors.modelo}
        error={Boolean(errors.modelo)}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        required
        name="marca"
        label="Marca del Equipo"
        value={this.state.marca}
        onChange={this.handleChange}
        fullWidth
        variant="outlined"
        size="small"
        helperText={errors.marca}
        error={Boolean(errors.marca)}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        required
        name="ubicacion"
        label="Ubicación del Equipo"
        value={this.state.ubicacion}
        onChange={this.handleChange}
        fullWidth
        variant="outlined"
        size="small"
        helperText={errors.ubicacion}
        error={Boolean(errors.ubicacion)}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        required
        name="servicio"
        label="Servicio"
        value={this.state.servicio}
        onChange={this.handleChange}
        fullWidth
        variant="outlined"
        size="small"
        helperText={errors.servicio}
        error={Boolean(errors.servicio)}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <FormControl fullWidth size="small" error={Boolean(errors.tipo)}>
        <InputLabel>Tipo Equipo</InputLabel>
        <Select
          name="tipo"
          value={this.state.tipo}
          onChange={this.handleChange}
          label="Tipo Equipo"
        >
          <MenuItem value=""><em>Seleccione</em></MenuItem>
          <MenuItem value="mobiliario">Mobiliario</MenuItem>
          <MenuItem value="industrial">Industrial</MenuItem>
          <MenuItem value="automotriz">Automotriz</MenuItem>
          <MenuItem value="computo">Computo</MenuItem>
          <MenuItem value="electrodomestico">Electrodoméstico</MenuItem>
          <MenuItem value="ofimatico">Ofimático</MenuItem>
          <MenuItem value="seguridad">Seguridad</MenuItem>
          <MenuItem value="telecomunicacion">Telecomunicación</MenuItem>
          <MenuItem value="audiovisual">Audiovisual</MenuItem>
          <MenuItem value="hidrosanitario">Hidrosanitario</MenuItem>
          <MenuItem value="energia">Energía</MenuItem>
          <MenuItem value="climatizacion">Climatización</MenuItem>
        </Select>
        <FormHelperText>{errors.tipo}</FormHelperText>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <FormControl fullWidth size="small" error={Boolean(errors.tipouso)}>
        <InputLabel>Tipo de Uso</InputLabel>
        <Select
          name="tipouso"
          value={this.state.tipouso}
          onChange={this.handleChange}
          label="Tipo de Uso"
        >
          <MenuItem value=""><em>Seleccione</em></MenuItem>
          <MenuItem value="Medico">Médico</MenuItem>
          <MenuItem value="Basico">Básico</MenuItem>
          <MenuItem value="Apoyo">Apoyo</MenuItem>
          <MenuItem value="N/A">N/A</MenuItem>
        </Select>
        <FormHelperText>{errors.tipouso}</FormHelperText>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <FormControl fullWidth size="small" error={Boolean(errors.reqcalibracion)}>
        <InputLabel>Requiere Calibración</InputLabel>
        <Select
          name="reqcalibracion"
          value={this.state.reqcalibracion}
          onChange={this.handleChange}
          label="Requiere Calibración"
        >
          <MenuItem value=""><em>Seleccione</em></MenuItem>
          <MenuItem value="true">Sí</MenuItem>
          <MenuItem value="false">No</MenuItem>
        </Select>
        <FormHelperText>{errors.reqcalibracion}</FormHelperText>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={12}>
      <FormControl fullWidth size="small" error={Boolean(errors.movilfijo)}>
        <InputLabel>Equipo Móvil o Fijo</InputLabel>
        <Select
          name="movilfijo"
          value={this.state.movilfijo}
          onChange={this.handleChange}
          label="Equipo Móvil o Fijo"
        >
          <MenuItem value=""><em>Seleccione</em></MenuItem>
          <MenuItem value="Movil">Móvil</MenuItem>
          <MenuItem value="Fijo">Fijo</MenuItem>
        </Select>
        <FormHelperText>{errors.movilfijo}</FormHelperText>
      </FormControl>
    </Grid>

    <Grid item xs={12}>
      <TextField
        multiline
        rows={4}
        name="descripcion"
        label="Breve Descripción de Uso"
        value={this.state.descripcion}
        onChange={this.handleChange}
        fullWidth
        variant="outlined"
        size="small"
        helperText={errors.descripcion}
        error={Boolean(errors.descripcion)}
      />
    </Grid>

    
  </Grid>

<Typography
  sx={{
    color: '#0468BF',
    fontSize: '18px',
    fontWeight: 400,
    ml: 1,
    mt: 4,
    mb: 2
  }}
>
  Historial de Adquisición
</Typography>

<Grid container spacing={2}>
  <Grid item xs={12} sm={6}>
    <FormControl fullWidth size="small" error={Boolean(errors.adquisicion)}>
      <InputLabel>Forma Adquisición</InputLabel>
      <Select
        name="adquisicion"
        value={this.state.adquisicion}
        onChange={this.handleChange}
        label="Forma Adquisición"
      >
        <MenuItem value=""><em>Seleccione</em></MenuItem>
        <MenuItem value="compra">Compra</MenuItem>
        <MenuItem value="comodato">Comodato</MenuItem>
        <MenuItem value="donacion">Donación</MenuItem>
        <MenuItem value="otro">Otro</MenuItem>
      </Select>
      <FormHelperText>{errors.adquisicion}</FormHelperText>
    </FormControl>
  </Grid>

  <Grid item xs={12} sm={6}>
    <TextField
      required
      type="number"
      name="costo"
      label="Valor del Equipo"
      value={this.state.costo}
      onChange={this.handleChange}
      fullWidth
      size="small"
      variant="outlined"
      helperText={errors.costo}
      error={Boolean(errors.costo)}
    />
  </Grid>

  <Grid item xs={12} sm={6}>
    <TextField
      required
      type="date"
      name="fabricacion"
      label="Fecha Fabricación"
      value={this.state.fabricacion}
      onChange={this.handleChange}
      fullWidth
      size="small"
      InputLabelProps={{ shrink: true }}
      helperText={errors.fabricacion}
      error={Boolean(errors.fabricacion)}
    />
  </Grid>

  <Grid item xs={12} sm={6}>
    <TextField
      required
      type="date"
      name="fechaadquisicion"
      label="Fecha de Adquisición"
      value={this.state.fechaadquisicion}
      onChange={this.handleChange}
      fullWidth
      size="small"
      InputLabelProps={{ shrink: true }}
      helperText={errors.fechaadquisicion}
      error={Boolean(errors.fechaadquisicion)}
    />
  </Grid>

  <Grid item xs={12} sm={6}>
    <TextField
      required
      type="date"
      name="fechainstalacion"
      label="Fecha de Instalación"
      value={this.state.fechainstalacion}
      onChange={this.handleChange}
      fullWidth
      size="small"
      InputLabelProps={{ shrink: true }}
      helperText={errors.fechainstalacion}
      error={Boolean(errors.fechainstalacion)}
    />
  </Grid>

  <Grid item xs={12} sm={6}>
    <FormControl fullWidth size="small" error={Boolean(errors.garantia)}>
      <InputLabel>¿Equipo en Garantía?</InputLabel>
      <Select
        name="garantia"
        value={this.state.garantia}
        onChange={this.handleChange}
        label="¿Equipo en Garantía?"
      >
        <MenuItem value=""><em>Seleccione</em></MenuItem>
        <MenuItem value="true">Sí</MenuItem>
        <MenuItem value="false">No</MenuItem>
      </Select>
      <FormHelperText>{errors.garantia}</FormHelperText>
    </FormControl>
  </Grid>

  {this.state.garantia === 'true' && (
    <>
      <Grid item xs={12} sm={6}>
        <TextField
          required
          type="date"
          name="fechainiciogarantia"
          label="Fecha Inicio de Garantía"
          value={this.state.fechainiciogarantia}
          onChange={this.handleChange}
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
          helperText={errors.fechainiciogarantia}
          error={Boolean(errors.fechainiciogarantia)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          required
          type="date"
          name="fechafingarantia"
          label="Fecha Final de Garantía"
          value={this.state.fechafingarantia}
          onChange={this.handleChange}
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
          helperText={errors.fechafingarantia}
          error={Boolean(errors.fechafingarantia)}
        />
      </Grid>
    </>
  )}

  <Grid item xs={12} sm={6}>
    <TextField
      required
      name="pais"
      label="País de Fabricación"
      value={this.state.pais}
      onChange={this.handleChange}
      fullWidth
      size="small"
      variant="outlined"
      helperText={errors.pais}
      error={Boolean(errors.pais)}
    />
  </Grid>

  <Grid item xs={12} sm={6}>
    <TextField
      required
      name="nombrefabricante"
      label="Nombre del Fabricante"
      value={this.state.nombrefabricante}
      onChange={this.handleChange}
      fullWidth
      size="small"
      variant="outlined"
      helperText={errors.nombrefabricante}
      error={Boolean(errors.nombrefabricante)}
    />
  </Grid>

  <Grid item xs={12} sm={6}>
    <TextField
      required
      type="number"
      name="telfabricante"
      label="Teléfono del Fabricante"
      value={this.state.telfabricante}
      onChange={this.handleChange}
      fullWidth
      size="small"
      variant="outlined"
      helperText={errors.telfabricante}
      error={Boolean(errors.telfabricante)}
    />
  </Grid>

  <Grid item xs={12} sm={6}>
    <TextField
      required
      type="email"
      name="emailfabricante"
      label="Email del Fabricante"
      value={this.state.emailfabricante}
      onChange={this.handleChange}
      fullWidth
      size="small"
      variant="outlined"
      helperText={errors.emailfabricante}
      error={Boolean(errors.emailfabricante)}
    />
  </Grid>

  <Grid item xs={12} sm={6}>
    <TextField
      required
      type="number"
      name="vidautil"
      label="Años de Vida Útil"
      value={this.state.vidautil}
      onChange={this.handleChange}
      fullWidth
      size="small"
      variant="outlined"
      helperText={errors.vidautil}
      error={Boolean(errors.vidautil)}
    />
  </Grid>

  <Grid item xs={12} sm={6}>
    <TextField
      required
      name="proveedor"
      label="Proveedor del Equipo"
      value={this.state.proveedor}
      onChange={this.handleChange}
      fullWidth
      size="small"
      variant="outlined"
      helperText={errors.proveedor}
      error={Boolean(errors.proveedor)}
    />
  </Grid>

  <Grid item xs={12} sm={6}>
    <TextField
      required
      type="number"
      name="proveedortel"
      label="Teléfono del Proveedor"
      value={this.state.proveedortel}
      onChange={this.handleChange}
      fullWidth
      size="small"
      variant="outlined"
      helperText={errors.proveedortel}
      error={Boolean(errors.proveedortel)}
    />
  </Grid>

  <Grid item xs={12} sm={6}>
    <TextField
      required
      type="email"
      name="proveedoremail"
      label="Email del Proveedor"
      value={this.state.proveedoremail}
      onChange={this.handleChange}
      fullWidth
      size="small"
      variant="outlined"
      helperText={errors.proveedoremail}
      error={Boolean(errors.proveedoremail)}
    />
  </Grid>
</Grid>

<Typography
  sx={{
    color: '#0468BF',
    fontSize: '18px',
    fontWeight: 400,
    ml: 1,
    mt: 4,
    mb: 2
  }}
>
  Datos Técnicos del Equipo
</Typography>

<Grid container spacing={2}>
  <Grid item xs={12} sm={6}>
    <FormControl fullWidth size="small" error={Boolean(errors.tipotec)}>
      <InputLabel>Tecnología Predominante</InputLabel>
      <Select
        name="tipotec"
        value={this.state.tipotec}
        onChange={this.handleChange}
        label="Tecnología Predominante"
      >
        <MenuItem value=""><em>Seleccione</em></MenuItem>
        <MenuItem value="Electrónica">Electrónica</MenuItem>
        <MenuItem value="Eléctrica">Eléctrica</MenuItem>
        <MenuItem value="Mecánica">Mecánica</MenuItem>
        <MenuItem value="Hidraulica">Hidráulica</MenuItem>
        <MenuItem value="Neumatica">Neumática</MenuItem>
        <MenuItem value="Vapor">Vapor</MenuItem>
        <MenuItem value="Otra">Otra</MenuItem>
      </Select>
      <FormHelperText>{errors.tipotec}</FormHelperText>
    </FormControl>
  </Grid>

  <Grid item xs={12} sm={6}>
    <FormControl fullWidth size="small" error={Boolean(errors.fuente)}>
      <InputLabel>Fuente de Alimentación</InputLabel>
      <Select
        name="fuente"
        value={this.state.fuente}
        onChange={this.handleChange}
        label="Fuente de Alimentación"
      >
        <MenuItem value=""><em>Seleccione</em></MenuItem>
        <MenuItem value="AC">AC</MenuItem>
        <MenuItem value="DC">DC</MenuItem>
        <MenuItem value="Gas Medicinal">Gas Medicinal</MenuItem>
        <MenuItem value="Agua">Agua</MenuItem>
        <MenuItem value="Aire">Aire</MenuItem>
        <MenuItem value="Aire comprimido">Aire Comprimido</MenuItem>
        <MenuItem value="Energia Solar">Energía Solar</MenuItem>
        <MenuItem value="Derivados del Petroleo">Derivados del Petróleo</MenuItem>
        <MenuItem value="Vapor">Vapor</MenuItem>
        <MenuItem value="Otra">Otra</MenuItem>
      </Select>
      <FormHelperText>{errors.fuente}</FormHelperText>
    </FormControl>
  </Grid>

  {[
    { name: 'urlmanual', label: 'Link del Manual o Ficha Técnica' },
    { name: 'urlmanualuser', label: 'Link del Manual de Usuario' },
    { name: 'urlfactura', label: 'Link de Factura' },
    { name: 'urlimportacion', label: 'Link de la Declaración de importación (Si Aplica)' }
  ].map((field) => (
    <Grid item xs={12} key={field.name}>
      <TextField
        required
        name={field.name}
        label={field.label}
        value={this.state[field.name]}
        onChange={this.handleChange}
        fullWidth
        variant="outlined"
        size="small"
        helperText={errors[field.name]}
        error={Boolean(errors[field.name])}
      />
    </Grid>
  ))}

  {[
    ['tensionmin', 'Tensión Min (V)'],
    ['tensionmax', 'Tensión Max (V)'],
    ['corrientemin', 'Corriente Min (A)'],
    ['corrientemax', 'Corriente Max (A)'],
    ['velocidad', 'Velocidad'],
    ['potencia', 'Potencia del Equipo (W)'],
    ['presion', 'Presión de Entrada'],
    ['capacidad', 'Capacidad'],
    ['temperatura', 'Temperatura de Operación'],
    ['frecuencia', 'Frecuencia (Hz)'],
    ['alto', 'Medidas Alto (cm)'],
    ['ancho', 'Medidas Ancho (cm)'],
    ['largo', 'Medidas Largo (cm)'],
    ['peso', 'Peso (Kg)']
  ].map(([name, label]) => (
    <Grid item xs={12} sm={6} key={name}>
      <TextField
        required
        type="number"
        name={name}
        label={label}
        value={this.state[name]}
        onChange={this.handleChange}
        fullWidth
        variant="outlined"
        size="small"
        helperText={errors[name]}
        error={Boolean(errors[name])}
      />
    </Grid>
  ))}
</Grid>

<Typography
  sx={{
    color: '#0468BF',
    fontSize: '18px',
    fontWeight: 400,
    ml: 1,
    mt: 4,
    mb: 2
  }}
>
  Información Adicional
</Typography>

<Grid container spacing={2}>
  <Grid item xs={12}>
    <TextField
      multiline
      rows={4}
      name="rutinamto"
      label="Rutina de Mantenimiento"
      value={this.state.rutinamto}
      onChange={this.handleChange}
      fullWidth
      variant="outlined"
      size="small"
      helperText={errors.rutinamto}
      error={Boolean(errors.rutinamto)}
    />
  </Grid>

  <Grid item xs={12}>
    <TextField
      multiline
      rows={4}
      name="recomendaciones"
      label="Recomendaciones de Uso"
      value={this.state.recomendaciones}
      onChange={this.handleChange}
      fullWidth
      variant="outlined"
      size="small"
      helperText={errors.recomendaciones}
      error={Boolean(errors.recomendaciones)}
    />
  </Grid>

  <Grid item xs={12}>
    <FormControl fullWidth size="small" error={Boolean(errors.accesorio)}>
      <InputLabel>¿El equipo tiene accesorios?</InputLabel>
      <Select
        name="accesorio"
        value={this.state.accesorio}
        onChange={this.handleChange}
        label="¿El equipo tiene accesorios?"
      >
        <MenuItem value=""><em>Seleccione</em></MenuItem>
        <MenuItem value="true">Sí</MenuItem>
        <MenuItem value="false">No</MenuItem>
      </Select>
      <FormHelperText>{errors.accesorio}</FormHelperText>
    </FormControl>
  </Grid>

  {this.state.accesorio === 'true' && (
    <>
      {[
        ['1', 'accesorionombre1', 'accesorioref1', 'accesorioserie1'],
        ['2', 'accesorionombre2', 'accesorioref2', 'accesorioserie2'],
        ['3', 'accesorionombre3', 'accesorioref3', 'accesorioserie3']
      ].map(([index, nombre, ref, serie]) => (
        <React.Fragment key={index}>
          <Grid item xs={12} sm={4}>
            <TextField
              required
              name={nombre}
              label={`Nombre Accesorio ${index}`}
              value={this.state[nombre]}
              onChange={this.handleChange}
              fullWidth
              size="small"
              variant="outlined"
              helperText={errors[nombre]}
              error={Boolean(errors[nombre])}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              required
              name={ref}
              label="Referencia"
              value={this.state[ref]}
              onChange={this.handleChange}
              fullWidth
              size="small"
              variant="outlined"
              helperText={errors[ref]}
              error={Boolean(errors[ref])}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              required
              name={serie}
              label="Serie"
              value={this.state[serie]}
              onChange={this.handleChange}
              fullWidth
              size="small"
              variant="outlined"
              helperText={errors[serie]}
              error={Boolean(errors[serie])}
            />
          </Grid>
        </React.Fragment>
      ))}
    </>
  )}
</Grid>
                  
                      
            
            </DialogContent>
          

           
                </div>
               
                )}

<DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
             </MyButton>

             {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />
              ) : (
                this.state.aprobado.mensaje ? (
                              
                  <MyButton tip="Ir a Inventario" onClick={this.handleClose}>
                    <FaCheckCircle color="#20B90C" className="icon-formulario" />
                  </MyButton>
                  
                ) : (
                  <MyButton tip="Crear Equipo" onClick={this.handleSubmit}>
                    <FaPlus color="#03178C" className="icon-formulario" />
                  </MyButton>
                )
              )}
            
            
          </DialogActions>
                 </Dialog>
          
            </Fragment>
            
        )
    }
}

NuevoMobiliario.propTypes = {
    postMobiliario: PropTypes.func.isRequired,
    getMobiliarios:PropTypes.func.isRequired,
    clienteId: PropTypes.string.isRequired,
    clearErrors:PropTypes.func.isRequired,
    UI:PropTypes.object.isRequired  
  };

const mapActionsToProps={postMobiliario,getMobiliarios,clearErrors};

const mapStateToProps = (state)=>({
    user:state.user,
    UI:state.UI
})



export default connect(mapStateToProps,mapActionsToProps)(NuevoMobiliario);


